import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=36d13d7b&"
import script from "./DealerList.vue?vue&type=script&lang=ts&"
export * from "./DealerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports